<ion-grid class="confirmation-body">
  <ion-row class="col-md-reverse">
  
    <!-- LEFT SIDE -->
    <ion-col size="12" size-md class="phi-align-content-center">
      <div class="center-content" *ngIf="(moduleName!=1 && moduleName!=4 && moduleName!=2 && moduleName!='Manager' && moduleName!='HODManager')">
        <label class="mr-10">Rejected</label>
        <mat-slide-toggle class="mr-10"
          *ngIf="(moduleName!=1 && moduleName!=4 && moduleName!=2)"
          [(ngModel)]="isToggleOn"
          (change)="onChangeSwitch($event)">
        </mat-slide-toggle>
        <label class="mr-10">Approved</label>
      </div>
  
      <div class="w-100 mw-sm-250" *ngIf="moduleName==1">
        <ng-multiselect-dropdown class="ml-5"
          [placeholder]="'Select Status'"
          [settings]="dropdownSettings"
          [data]="getStatusList"
          [(ngModel)]="selectedSatus"
          (onSelect)="onSelectStatus()"
          (onDeSelect)="onDeSelectStatus()"
          (onSelectAll)="selectAllStatus($event)"
          (onDeSelectAll)="onDeSelectAllStatus()">
        </ng-multiselect-dropdown>
      </div>
    </ion-col>
  
    <!-- RIGHT SIDE -->
    <ion-col size="12" size-md="auto" class="phi-align-content-center">
      <div class="d-flex align-items-center justify-content-end" style="gap: 12px;">
        
        <!-- Refresh Icon -->
        <span class="fs-20 material-icons btn-reset cursor-pointer"
          [class.clicked]="isClicked"
          (click)="resetGrid(); isClicked = true"
          (animationend)="isClicked = false">
          refresh
        </span>
  
        <!-- Download Icon -->
        <span class="icon-download fs-20 material-icons cursor-pointer" style="cursor: pointer;"
          (click)="onBtExport()">
          download
        </span>
  
        <!-- Close Icon -->
        <span [mat-dialog-close]
          class="fs-30 fs_24ForMobile material-icons popup-close-icon cursor-pointer" style="cursor: pointer;">
          close
        </span>
  
      </div>
    </ion-col>
  
  </ion-row>
  
  <!-- Scrollable Table -->
  <ion-row>
    
    <ion-col size="12">
      <mat-sidenav-container style="height: 100%;">
        <!-- Main Content with AG Grid -->
        <mat-sidenav-content>
       
          <ag-grid-angular
            style="width: 100%; height: 500px;"
            class="ag-theme-quartz"
            [rowData]="allTeamMemberReimbursementApprove"
            [columnDefs]="taskColumnHeaderInfoForFinanse"
            [gridOptions]="gridOptions"
            [defaultColDef]="defaultColDef"
            (gridReady)="onGridReady($event)"
            (rowClicked)="onRowClicked($event)"
            [pagination]="pagination"
            [paginationPageSize]="paginationPageSize"
            [paginationPageSizeSelector]="paginationPageSizeSelector"
            [detailRowAutoHeight]="detailRowAutoHeight"
            [localeText]="{ noRowsToShow: 'No Data Found' }"
          >
          </ag-grid-angular>
        </mat-sidenav-content>
        <!-- Right Side Sidenav -->
        <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
          <!-- HEADER -->
          <div class="details-header">
            <h2>Reimbursement Details</h2>
            <button mat-icon-button (click)="closeDetails()">
              <mat-icon class="close-icon">close</mat-icon>
            </button>
          </div>
        
          <!-- CONTENT -->
          <div class="details-content" *ngIf="selectedRow">
            <mat-card class="detail-card" *ngFor="let col of taskColumnHeaderInfoForFinanse">
              <mat-card-content>
                <div class="detail-row">
                  <mat-icon class="detail-icon">trending_flat</mat-icon>
                  <div class="detail-text">
                    
                    <!-- LABEL -->
                    <span class="detail-label">{{ col.headerName }}</span>
        
                    <!-- STATUS BADGE -->
                    <ng-container *ngIf="col.headerName === 'Status'; else approvalCheck">
                      <span class="status-badge"
                            [ngClass]="{
                              'approved': selectedRow[col.field]?.toUpperCase().includes('APPROVED'),
                              'rejected': selectedRow[col.field]?.toUpperCase().includes('REJECTED'),
                              'pending': selectedRow[col.field]?.toUpperCase().includes('PENDING')
                            }">
                        {{ formatStatus(selectedRow[col.field]) }}
                      </span>
                    </ng-container>
        
                    <!-- APPROVAL BADGE -->
                    <ng-template #approvalCheck>
                      <ng-container *ngIf="col.headerName === 'Approval'; else normalContent">
                        <span class="status-badge"
                              [ngClass]="{
                                'approved': selectedRow[col.field] === 'APPROVED',
                                'rejected': selectedRow[col.field] === 'REJECTED',
                                'pending': selectedRow[col.field] === 'PENDING'
                              }">
                          {{ formatStatus(selectedRow[col.field]) }}
                        </span>
                      </ng-container>
                    </ng-template>
        
                    <!-- NORMAL DATA / DOCUMENT -->
                    <ng-template #normalContent>
                      <ng-container *ngIf="col.field === 'uploadDocument'; else textValue">
                        <ng-container *ngIf="selectedRow[col.field]; else noFile">
                          <img src="assets/icon/yellowdownload.png"
                              alt="download"
                              width="18" height="18"
                              style="cursor:pointer"
                              (click)="openFile(downloadDialogRenderer(selectedRow[col.field]))"
                          />
                        </ng-container>
                        <ng-template #noFile>
                          <span></span>
                        </ng-template>
                      </ng-container>
                      
        
                      <ng-template #textValue>
                        <span>
                          {{ (col.field === 'date' || col.field === 'dateOfExpense') 
                          ? formatDate(selectedRow[col.field]) 
                          : selectedRow[col.field] || selectedRow[col.field]}}
                        </span>
                      </ng-template>
                    </ng-template>
        
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </mat-sidenav>
      </mat-sidenav-container>
      
    </ion-col>
  </ion-row>
</ion-grid>
